// extracted by mini-css-extract-plugin
module.exports = {"detailBlock":"styles_detailBlock__sQGrz","title":"styles_title__fFEJH","description":"styles_description__QCO7a"};